
  import { defineComponent, toRefs } from 'vue';
  import { ChooseUserFieldWithSelectAllProps } from '@/ui/components/user/chooseUserFieldWithSelectAllProps';
  import { ChooseUserField } from '@/ui/components/user/ChooseUserField';
  import { SelectOption } from '@/ui/types';
  import { toasted } from '@/ui/helpers';
  import { t } from '@/ui/i18n/i18n';
  import { Icon } from '@/ui/components/icon/Icon';

  export default defineComponent<ChooseUserFieldWithSelectAllProps>({
    name: 'ChooseUserFieldWithSelectAll',
    components: {
      ChooseUserField,
      Icon,
    },
    props: [
      'options',
      'value',
      'errors',
      'label',
      'placeholder',
      'identifier',
      'hideLabel',
      'name',
      'maxListedOptions',
      'required',
      'disabled',
      'selectAllEnabled',
      'deselectAllEnabled',
    ],
    setup(props, context) {
      const {
        options,
        value,
        errors,
        required,
        disabled,
        selectAllEnabled,
        deselectAllEnabled,
      } = toRefs(props);

      const updateValue = async (id: number) => {
        emitChange([...value.value, `user_${id}`]);
        toasted.success(t('user.created'), { duration: 5000 });

        context.emit('update-options');
      };

      const emitChange = (value: string[] | number[]) => {
        context.emit('input', value);
      };

      const emitSelectALl = () => {
        const allAssignees = options.value.map((assignee: SelectOption<number | string>) => assignee.value);
        context.emit('input', allAssignees);
      };

      const emitDeselectAll = () => {
        context.emit('input', []);
      };

      return {
        fieldOptions: options,
        fieldValue: value,
        fieldErrors: errors,
        fieldLabel: props.label,
        fieldPlaceholder: props.placeholder,
        fieldIdentifier: props.identifier,
        fieldHideLabel: props.hideLabel,
        fieldName: props.name,
        fieldRequired: required,
        fieldDisabled: disabled,
        selectAllFieldEnabled: selectAllEnabled,
        deselectAllFieldEnabled: deselectAllEnabled,
        fieldMaxListedOptions: props.maxListedOptions,
        emitChange,
        emitSelectALl,
        emitDeselectAll,
        updateValue,
      };
    },
  });
